import React, { useEffect, useState } from "react";
import styles from "./Tableheader.module.scss";
import ExportButton from "../../components/ExportButton/ExportButton";
import StatusView from "../../components/StatusView/StatusView";
import { ReactComponent as DownloadIcon } from "../../assets/images/csv.svg";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputAdornment } from "@mui/material";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import TableFilter from "../TableFilter/TableFilter";
import AddIcon from "@mui/icons-material/Add";

type TableHeaderProps = {
	pageName?: string;
	dataLength?: number;
	data?: any;
	newButton?: React.ReactNode;
	dropdown?: boolean;
	setDropdown?: React.Dispatch<React.SetStateAction<boolean>>;
	value?: string | React.ReactNode;
	setValue?: React.Dispatch<React.SetStateAction<string>>;
	FilterComponent?: React.ReactNode;
	handleClick?: () => void;
	handleClickAddNew?: () => void;
	entries?: boolean;
	filtering?: boolean;
	exporting?: boolean;
	addNew?: boolean;
	newName?: string;
	placeHolder?: string;
	searchfn?: boolean;
	noDownload?: boolean;
	noFilter?: boolean;
};

const CssTextField = withStyles({
	root: {
		"& label.Mui-focused": {
			color: "white",
		},
		"& .MuiInput-underline:after": {
			// borderBottomColor: 'yellow',
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				borderColor: "#008243",
			},
			"&:hover fieldset": {
				borderColor: "#008243",
			},
			"&.Mui-focused fieldset": {
				borderColor: "#008243",
			},
		},
	},
})(TextField);

const TableHeader = ({
	pageName,
	dataLength,
	data,
	newButton,
	value,
	setValue,
	dropdown,
	setDropdown,
	placeHolder,
	FilterComponent,
	entries = true,
	filtering = true,
	exporting = true,
	searchfn = true,
	addNew = false,
	newName = "",
	handleClick,
	handleClickAddNew,
}: TableHeaderProps) => {
	const [isDesktop, setDesktop] = useState(window.innerWidth > 800);

	const updateMedia = () => {
		setDesktop(window.innerWidth > 800);
	};

	useEffect(() => {
		window.addEventListener("resize", updateMedia);
		return () => window.removeEventListener("resize", updateMedia);
	});

	return (
		<div className={styles.pageTop}>
			{dataLength && entries ? (
				<div className={styles.transactions}>{dataLength} entries</div>
			) : (
				<h3 className={styles.newH3}>{pageName}</h3>
			)}

			<div className={styles.actions}>
				<div className={styles.actionButtons}>
					{filtering && (
						<TableFilter
							dropdown={dropdown}
							setDropdown={setDropdown}
							FilterComponent={FilterComponent}
						/>
					)}
					{exporting && (
						<div>
							<button onClick={handleClick} className={styles.downloadButton}>
								<DownloadIcon className={styles.downloadIcon} />
								Download
							</button>
						</div>
					)}
					{addNew && (
						<div>
							<button
								onClick={handleClickAddNew}
								className={styles.addNewButton}
							>
								<span style={{ margin: "0 0 0 3px" }}>{newName}</span>
							</button>
						</div>
					)}

					<div className={styles.headerButton}>{newButton}</div>
				</div>
			</div>
		</div>
	);
};

export default TableHeader;
